var _circle, _path, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36,
    r: 34.2,
    stroke: "#E1E1E1",
    strokeWidth: 3.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9 21.5999C20.9177 21.5999 18.5 24.0175 18.5 26.9999V42.2971C18.5 42.2989 18.5 42.3006 18.5 42.3023V46.7999C18.5 49.7822 20.9177 52.1999 23.9 52.1999H49.1C52.0823 52.1999 54.5 49.7822 54.5 46.7999V26.9999C54.5 24.0175 52.0823 21.5999 49.1 21.5999H23.9ZM22.1 43.0453V46.7999C22.1 47.794 22.9059 48.5999 23.9 48.5999H49.1C50.0941 48.5999 50.9 47.794 50.9 46.7999V44.8453L46.3273 40.2726L40.8208 45.1674C39.3508 46.474 37.1043 46.3591 35.7753 44.9093L28.3435 36.8019L22.1 43.0453ZM50.9 39.7542V26.9999C50.9 26.0057 50.0941 25.1999 49.1 25.1999H23.9C22.9059 25.1999 22.1 26.0057 22.1 26.9999V37.9541L25.7979 34.2563C27.2472 32.807 29.6123 32.8584 30.9972 34.3693L38.429 42.4767L43.9356 37.582C45.3603 36.3156 47.5251 36.3792 48.8729 37.7271L50.9 39.7542Z",
    fill: "#E1E1E1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.9998,
    cy: 31.4999,
    rx: 2.7,
    ry: 2.7,
    fill: "#E1E1E1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/default-image.9026ea41e5c530e16dbb2240fe07a0d9.svg";
export { ForwardRef as ReactComponent };